import {debounce} from "@weseus/cms-core/assets/js/helpers";

export default class AutoSubmitExtension {
	constructor(naja) {
		this.naja = naja;
		naja.addEventListener('init', () => {
			this._init(document);
		});
		naja.snippetHandler.addEventListener('afterUpdate', (event) => {
			this._init(event.snippet);
		});
	}

	_init(block) {
		block.querySelectorAll('form.autosubmit').forEach((form) => {
			form.addEventListener('keyup', debounce((e) => {
				if (form.classList.contains('ajax')) {
					this.naja.uiHandler.submitForm(form);
				} else {
					form.submit();
				}
			}, 2000));
		});
	}

}